import { useCallback, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { IncentivesEvent } from '@bonusly/common-incentives';
import { useDispatch } from '@bonusly/events';
import { useAnalytics } from '@bonusly/who-am-i';

export function IncentiveDetails() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { trackEvent } = useAnalytics();
	const trackedView = useRef(false);

	const onClose = useCallback(() => {
		navigate('/incentives');
	}, [navigate]);

	useEffect(() => {
		dispatch(IncentivesEvent.OpenClaimIncentive, { id, onClose });
	}, [id, dispatch, onClose]);

	useEffect(() => {
		if (trackedView.current) return;
		trackEvent(IncentivesEvent.IncentiveDetailsPageViewed, { id });
		trackedView.current = true;
	}, [id, trackEvent]);

	return null;
}
